import { Box, Typography } from '@mui/material'
import React from 'react'

import { t } from '@f-fertighaus/applications/Next/public/locales/de'

export const SectionDescription = () => {
  return (
    <Box sx={{ py: 3 }}>
      <Box sx={{ pb: 1 }}>
        <Typography variant='bodyTitle' component='p'>
          {t('houseDetailPage.floor_plans.description-header')}
        </Typography>
      </Box>
      <Typography variant='body1'>
        {t('houseDetailPage.floor_plans.description')}
      </Typography>
    </Box>
  )
}
